import gql from 'graphql-tag';

export const GET_MEMBERSHIP_COSTS = gql`
  query getMembershipCosts(
    $program: Program!
    $country: Country!
    $period: Int!
  ) {
    me {
      membershipCosts(program: $program, period: $period, cadence: 1) {
        price {
          currency
          amount
        }
        handlingFee(country: $country) {
          amount
          currency
        }
        shippingCost(country: $country) {
          amount
          currency
        }
      }
    }
  }
`;
